import { useLang } from "@/i18n/LangContext";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";

export default function Legal({ kind }) {
  const { t } = useLang();
  const doc = t(kind);
  return (
    <>
      <Seo page={kind} />
      <section className="bg-ink pt-[140px] pb-20 lg:pt-[180px]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight">{doc.title}</h1>
            <p className="mt-4 text-xs tracking-widest text-steel">{doc.updated}</p>
          </Reveal>
          <div className="mt-12 space-y-10">
            {doc.sections.map((s, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <h2 className="font-display text-lg font-bold text-electric">{s.h}</h2>
                <p className="mt-3 text-sm sm:text-base text-steel leading-relaxed">{s.p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
